import { render, staticRenderFns } from "./users-change.vue?vue&type=template&id=891be03c&scoped=true"
import script from "./users-change.vue?vue&type=script&lang=js"
export * from "./users-change.vue?vue&type=script&lang=js"
import style0 from "./users-change.vue?vue&type=style&index=0&id=891be03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891be03c",
  null
  
)

export default component.exports